import React, { useEffect } from "react"

import { ScrollTopButton } from "@components/scroll-top-button"

import { Footer } from "./footer"
import { FeefoWidget } from "./footer/feefo-widget"
import { Header } from "./header"
import { GoogleShopping } from "./header/google-shopping"

const FEEFO_LOADER_SRC = "https://api.feefo.com/api/javascript/first-fence"

const Layout = ({ location, children }) => {
  // The home page renders no Feefo widget — its reviews come from build-time
  // GraphQL (allFeefoServiceReview) — so it does not need the runtime loader.
  // Skipping it there avoids ~280KB (loader + widget + three Poppins woff2
  // files served from fonts.feefo.com) on our highest-traffic page.
  const needsFeefoRuntime = location?.pathname !== "/"

  useEffect(() => {
    if (typeof window === "undefined" || !needsFeefoRuntime) {
      return
    }

    // Layout remounts on route change, so guard against re-injecting a loader
    // that is already on the page.
    if (document.querySelector(`script[src="${FEEFO_LOADER_SRC}"]`)) {
      return
    }

    const script = document.createElement("script")
    script.src = FEEFO_LOADER_SRC
    script.async = true

    script.setAttribute("type", "text/javascript")
    script.setAttribute("data-cookieyes", "cookieyes-functional")

    document.body.appendChild(script)

    // No cleanup: removing the tag does not unload Feefo, and re-adding it on
    // the next route change is what caused the duplicate requests.
  }, [needsFeefoRuntime])
  return (
    <div>
      <GoogleShopping location={location} />
      <Header location={location} />
      <main>{children}</main>
      <ScrollTopButton location={location} />
      {needsFeefoRuntime && <FeefoWidget />}
      <Footer location={location} />
    </div>
  )
}

export default Layout
